import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { WasteType } from '../../domain/models'
import { IWasteTypeProvider } from '../../domain/providers/WasteTypeProvider'
import { IPaginatedData, IWasteTypeData } from './types'

class WasteTypeProvider implements IWasteTypeProvider {
  public http: AxiosInstance

  constructor(baseURL: string) {
    const config: AxiosRequestConfig = {
      baseURL: `${baseURL}/api/v1`,
      headers: {
        'content-type': 'application/json'
      }
    }
    this.http = axios.create(config)
  }

  public static toWasteType(data: IWasteTypeData): WasteType {
    return new WasteType({
      id: data.id,
      name: data.name,
      picture: data.iconUrl,
    })
  }

  async fetchAvailableWasteType(): Promise<Array<WasteType>> {
    const { data } = await this.http.get<IPaginatedData<IWasteTypeData>>('/wastetypes?size=100')

    return data.content.map((it) => WasteTypeProvider.toWasteType(it))
  }
}

export default WasteTypeProvider
